import { Directive, HostListener, Renderer2 } from '@angular/core';

/**
 * 限制只能輸入英文字母和數字的指令
 */
@Directive({
  selector: '[appAlphaNumericOnly]',
  standalone: true,
})
export class AlphaNumericOnlyDirective {
  constructor(private renderer: Renderer2) {}

  @HostListener('input', ['$event'])
  onInput(event: Event) {
    const input = event.target as HTMLInputElement;
    const sanitized = input.value.replace(/[^a-zA-Z0-9]/g, '');
    if (input.value !== sanitized) {
      this.renderer.setProperty(input, 'value', sanitized);
      // 觸發 Angular 的變更檢測
      input.dispatchEvent(new Event('input'));
    }
  }
}
